module.exports = __webpack_public_path__ + "static/stirge-f4c4f3bcd67db308d91aede21869630b.jpg";